import { useDispatch, useSelector } from 'react-redux'
import { setTheme, getTheme } from 'stateManagement/actions/themeAction'
import { checkNull } from "utils/utils";

const useTheme = (themeName) => {
    const currentTheme = useSelector(state => state.themeState.theme);
    const themeDispatcher = useDispatch();        


    return {
        theme: currentTheme,
        setTheme: !checkNull(themeName) ?  themeDispatcher(setTheme(themeName)) : currentTheme,
        getTheme: themeDispatcher(getTheme()),
    }
}

export default useTheme;